import { render } from "./DoubleConfirm.vue?vue&type=template&id=cd72e276&scoped=true"
import script from "./DoubleConfirm.vue?vue&type=script&lang=js"
export * from "./DoubleConfirm.vue?vue&type=script&lang=js"

import "./DoubleConfirm.vue?vue&type=style&index=0&id=cd72e276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd72e276"]])

export default __exports__